import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { addPendingUserApi, checkInviteCodeApi } from "../../../../api/api";
import { Toast } from "../../toast/Toast";
import BasicInformationInput from "./component/BasicInformationInput";
import Section from "./component/Section";
import TextAreaSection from "./component/TextAreaSection";
import RangeSlider from "../../RangeSlider";

export default function AddUserModal({
  isVisible,
  setIsVisible,
  pendingData,
  setPendingData,
}) {
  const initialFormState = {
    name: "",
    email: "",
    birthday: "",
    gender: "",
    enrolled: "",
    insurance: "",
    phone: "",
    provider: "",
    icdCode: "",
    problemList: "",
    treatmentGoals: "",
    readingsPerDay: "3",
    drinksPerDay: "2",
    avgBAC: "0.3",
  };

  const [newUserData, setNewUserData] = useState(initialFormState);

  const validateForm = () => {
    const mandatoryFields = [
      "name",
      "email",
      "birthday",
      "gender",
      "provider",
      "insurance",
      "phone",
      "enrolled",
      "problemList",
      "icdCode",
      "treatmentGoals",
      "readingsPerDay",
      "drinksPerDay",
      "avgBAC",
    ];
    for (let field of mandatoryFields) {
      if (!newUserData[field]) {
        return false;
      }
    }
    return true;
  };

  const generateInviteCode = async (doctor) => {
    const code =
      doctor?.doctorCode?.slice(0, 3) + Math.floor(Math.random() * 90 + 100);
    if (code) {
      const res = await checkInviteCodeApi({ inviteCode: code });
      if (res?.error) {
        Toast.fire({
          icon: "error",
          title: "Something went wrong",
        });
      } else {
        if (res?.data === "code already exists") {
          generateInviteCode(doctor);
        } else {
          return code;
        }
      }
    }
  };

  const handleAddUser = async () => {
    if (!validateForm()) {
      alert("Please fill in all mandatory fields.");
      return;
    }
    const doctor = JSON.parse(localStorage.getItem("doctor"));
    const inviteCode = await generateInviteCode(doctor);
    if (inviteCode) {
      newUserData["inviteCode"] = inviteCode?.toLowerCase();
      const pendingUserResponse = await addPendingUserApi(newUserData);
      if (pendingUserResponse.err) {
      } else {
        setPendingData([...pendingData, newUserData]);
        setNewUserData(initialFormState);
        setIsVisible(false);
        Toast.fire({
          icon: "success",
          title: "Added successfully",
        });
      }
    } else {
      Toast.fire({
        icon: "error",
        title: "Something went wrong!",
      });
    }
  };

  const handleAddUserModalCancel = () => {
    setIsVisible(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewUserData((prevUserData) => ({
      ...prevUserData,
      [name]: value,
    }));
  };

  const basicInformation = [
    {
      name: "Name",
      value: newUserData.name,
      type: "text",
      placeholder: "Type your name",
      key: "name",
    },
    {
      name: "Email",
      value: newUserData.email,
      type: "email",
      placeholder: "Type your email",
      key: "email",
    },
    {
      name: "Phone",
      value: newUserData.phone,
      type: "text",
      placeholder: "Type your phone number",
      key: "phone",
    },
    {
      name: "DOB",
      value: newUserData.birthday,
      type: "date",
      placeholder: "Type your DOB",
      key: "birthday",
    },
  ];

  const providerInformation = [
    {
      name: "Sex",
      value: newUserData.gender,
      type: "text",
      placeholder: "Type your Sex",
      key: "gender",
    },
    {
      name: "Enrolled",
      value: newUserData.enrolled,
      type: "text",
      placeholder: "Enrolled",
      key: "enrolled",
    },
    {
      name: "Insurance Name",
      value: newUserData.insurance,
      type: "text",
      placeholder: "Type your Insurance Name:",
      key: "insurance",
    },
    {
      name: "Provider",
      value: newUserData.provider,
      type: "text",
      placeholder: "Type your Provider",
      key: "provider",
    },
  ];

  const sliderInfomation = [
    {
      name: "Readings per day",
      value: newUserData.readingsPerDay,
      key: "readingsPerDay",
      min: 0,
      max: 6,
      step: 1,
    },
    {
      name: "# of drinks per day",
      value: newUserData.drinksPerDay,
      key: "drinksPerDay",
      min: 0,
      max: 4,
      step: 1,
    },
    {
      name: "AVG BAC",
      value: newUserData.avgBAC,
      key: "avgBAC",
      min: 0,
      max: 0.7,
      step: 0.1,
    },
  ];

  const icdCodeInput = {
    name: "ICD code",
    value: newUserData.icdCode,
    type: "text",
    placeholder: "Type your ICD code",
    key: "icdCode",
  };

  return (
    <Modal
      title="Add User"
      open={isVisible}
      onCancel={() => {
        handleAddUserModalCancel();
        setNewUserData(initialFormState);
      }}
      onOk={handleAddUser}
      width={1000}
      okButtonProps={{ style: { backgroundColor: "#1d4ed8" } }}
      okText="Save"
    >
      <form>
        <hr />
        <div className="flex border border-[#BBBBBB] rounded-xl mt-4 justify-between">
          <div className="w-[49%] border-r px-3 border-r-[#BBBBBB]  py-2">
            {basicInformation.map((input) => (
              <BasicInformationInput
                key={input.key}
                input={input}
                handleInputChange={handleInputChange}
              />
            ))}
          </div>
          <Section title="">
            {providerInformation.map((input) => (
              <BasicInformationInput
                key={input.key}
                input={input}
                handleInputChange={handleInputChange}
              />
            ))}
          </Section>
        </div>
        <div className="lg:flex">
          <div className="border border-[#BBBBBB] my-4 w-[40%]">
            <div className="mt-4 px-3">
              <BasicInformationInput
                input={icdCodeInput}
                handleInputChange={handleInputChange}
              />
            </div>
            <TextAreaSection
              title="Tracked Problem List"
              name="problemList"
              value={newUserData.problemList}
              placeholder="Tracked Problem List"
              handleInputChange={handleInputChange}
            />
          </div>
          <div className="border border-[#BBBBBB] my-4 w-[60%]">
            <h3 className="font-bold text-lg p-2 font-poppin">
              Measurable Treatment Goals
            </h3>
            <hr />
            <div className="flex ps-2">
              <div className="w-4/6 mt-2">
                {sliderInfomation.map((slider) => (
                  <RangeSlider
                    value={slider.value}
                    label={slider.name}
                    onChange={handleInputChange}
                    key={slider.key}
                    id={slider.key}
                    min={slider.min}
                    max={slider.max}
                    step={slider.step}
                  />
                ))}
              </div>
              <div className="w-full">
                <TextAreaSection
                  title="Measurable Treatment Goals"
                  name="treatmentGoals"
                  value={newUserData.treatmentGoals}
                  placeholder="Measurable Treatment Goals"
                  handleInputChange={handleInputChange}
                  showTitle={false}
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
}
